// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cluster-badge[data-v-81a99ac2]{cursor:default;border-radius:10px;font-size:12px;padding:2px 10px;max-width:250px;text-overflow:ellipsis;overflow:hidden}", ""]);
// Exports
module.exports = exports;
